<template>
  <div class="hot-tabs">
    <div class="tab">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="tab-item default_css page_text_font"
        :class="index == active_index ? 'active' : ''"
        :style="{ 'max-width': 100 / data.length + '%' }"
      >
        <button @click="active_index = index">
          <h4>{{ item.title }}</h4>
        </button>
      </div>
      <div class="slider"></div>
    </div>
    <template v-for="(item, index) in data">
      <div
        v-if="index == active_index"
        :key="index + 1"
        v-html="re_remover_class(item.content)"
        class="tinymce-content default_css page_text_font"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      category_all: [],
      active_index: null,
      products: [],
    };
  },
  methods: {
    active() {
      if (this.$(".hot-tabs .active").length) {
        //   this.products = this.category_all[this.active_index].posts;
        let width = this.$(".hot-tabs .active").width();
        let left =
          this.$(".hot-tabs .active").position().left +
          parseInt(this.$(".hot-tabs .active").css("marginLeft"));
        this.$(".hot-tabs .slider").css("width", width).css("left", left);
      }
    },
  },
  beforeMount() {
    this.active_index = 0;
    this.active();
  },
  mounted() {},
  watch: {
    active_index(newV) {
      this.$nextTick(this.active);
    },
  },
};
</script>

<style lang="scss" scoped>
.hot-tabs {
  .tab {
    position: relative;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin-bottom: 36px;
    border-bottom: 2px solid rgb(211, 212, 213);
    .tab-item {
      margin: 0px 36px;
      button {
        background-color: transparent;
        cursor: pointer;
        border: none;
        padding: 0px 30px 12px;
        transform: translateY(2px);
        outline: inherit;
      }
      h4 {
        font-weight: 700;
        font-size: 16px;
        line-height: 1.5;
        letter-spacing: 2px;
        text-transform: uppercase;
        color: rgb(33, 42, 47);
        margin: 0px;
        padding: 0px;
      }
      .active {
        opacity: 1;
        transition: opacity 250ms ease 0s;
        border-bottom: none;
      }
    }
    .slider {
      position: absolute;
      bottom: 0px;
      display: block;
      transform: translateY(2px);
      background-color: black;
      height: 2px;
      transition: all 250ms ease-out 0s;
    }
  }
}
@media (max-width: 767px) {
  .hot-tabs {
    .tab {
      justify-content: space-between;
      .tab-item {
        margin: 0px;
        width: 100%;
        text-align: center;

        button {
          padding: 0px 0px 6px;
          h4 {
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>